import { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import { TextInput } from '../../components/Field';
import { Card, CardBody } from '../../components/Card';
import { useAuthStore } from '../../app/authStore';
import { errorMessage } from '../../lib/api';

interface RedirectState {
  from?: string;
}

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const status = useAuthStore((state) => state.status);
  const sessionError = useAuthStore((state) => state.error);
  const login = useAuthStore((state) => state.login);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 会话过期被踢回登录页时，把 5xx 之类的会话错误展示出来
    if (sessionError) setError(sessionError);
  }, [sessionError]);

  if (status === 'authenticated') {
    return <Navigate to={(location.state as RedirectState | null)?.from ?? '/fleet'} replace />;
  }

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await login(email.trim(), password);
      navigate((location.state as RedirectState | null)?.from ?? '/fleet', { replace: true });
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-0 p-4 text-fg">
      <div className="w-full max-w-sm">
        <div className="mb-5 flex items-center gap-2.5">
          <span className="flex size-9 items-center justify-center rounded-lg bg-accent text-base font-bold text-accent-fg">
            H
          </span>
          <div className="flex flex-col leading-tight">
            <span className="text-base font-semibold">无人机运营监管平台</span>
            <span className="text-xs text-fg-subtle">Havorix Aero</span>
          </div>
        </div>

        <Card>
          <CardBody>
            <form className="flex flex-col gap-3.5" onSubmit={submit} noValidate>
              <TextInput
                label="邮箱"
                required
                type="email"
                autoComplete="username"
                autoFocus
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="admin@havorix.local"
              />

              <TextInput
                label="口令"
                required
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="请输入口令"
                error={error ?? undefined}
              />

              <Button type="submit" variant="primary" loading={submitting} block>
                登录
              </Button>
            </form>
          </CardBody>
        </Card>

        <p className="mt-3 text-center text-xs leading-relaxed text-fg-subtle">
          本地开发默认管理员：admin@havorix.local / Havorix@2026
          <br />
          首次登录会强制要求修改口令
        </p>
      </div>
    </div>
  );
}
